if(!customElements.get('custom-hero')){
    class CustomHero extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.initVideo();
            this.initParallaxSlide();

            this.adjustPaddingTop();
            this.adjustHeight();

            document.addEventListener('scroll', this.adjustPaddingTop.bind(this), false);
            document.addEventListener('scroll', this.adjustHeight.bind(this), false);
        }

        refresh(){
            if(this.controller){
                this.controller.destroy(true);
                this.scene.destroy(true);
            }

            this.init();
        }

        initVideo(){
            this.videos = this.querySelectorAll('video');
            this.videoPlaceholders = this.querySelectorAll('.hero__bg--slide-placeholder');
            this.videos.forEach(video => {
                const loadVideos = () => {
                    video.classList.add('loaded');
                    const idx = video.dataset.idx;
                    this.videoPlaceholders.forEach(item => {
                        if(item.dataset.idx === idx){
                            item.classList.add('loaded-video');
                        }
                    })
                }
                video.addEventListener('loadeddata', loadVideos)
                if (video.readyState >= 2) {
                    loadVideos();
                }

            })
        }

        initParallaxSlide(){
            if(this.querySelectorAll('.hero__slide').length < 2) return; 
        
            const tween = new TimelineLite();

            if(this.querySelector('.hero__slide--slide1')){
                tween.add(TweenLite.fromTo('#hero .hero__slide--slide1', 0.03,{
                        opacity: 1,
                        transform: "translateY(0) scale(1)",
                        zIndex: 1
                    },{
                        opacity: 1,
                        transform: "translateY(0) scale(1)",
                        zIndex: 1
                    }
                ))
                tween.add(TweenLite.fromTo('#hero .hero__slide--slide1', 0.05,{
                        opacity: 1,
                        transform: "translateY(0) scale(1)",
                        zIndex: 1
                    },{
                        opacity: 0,
                        transform: "translateY(-30%) scale(1.2)",
                        ease: "power1.out",
                        zIndex: -1
                    }
                ))
            }

            if(this.querySelector('.hero__bg--slide1')){
                tween.add(TweenLite.fromTo('#hero .hero__bg--slide1', 0.05, {
                        opacity: 1,
                        transform: "scale(1)"
                    }, {
                        opacity: 0,
                        transform: "scale(1.5)"
                    }
                ), "<")
            }

            if(this.querySelector('.hero__slide-pagination')){
                tween.add(TweenLite.fromTo('.hero__slide-pagination-bullet[data-idx="1"]', 0.05, {
                        height: "30px"
                    },
                    {
                        height: "10px"
                    }
                ), "<")
                tween.add(TweenLite.fromTo('.hero__slide-pagination-bullet[data-idx="2"]', 0.05, {
                        height: "10px"
                    },
                    {
                        height: "30px"
                    }
                ), "<")
            }
  
            if(this.querySelector('.hero__bg--slide2')){
                tween.add(TweenLite.fromTo('#hero .hero__bg--slide2', 0.05, {
                        opacity: 0,
                        transform: "scale(1.5)"
                    }, {
                        opacity: 1,
                        transform: "scale(1)"
                    }
                ), "<")
            }
            
            if(this.querySelector('.hero__slide--slide2')){
                tween.add(TweenLite.fromTo('#hero .hero__slide--slide2', 0.05, {
                        opacity: 0,
                        transform: "translateY(30%) scale(1.2)",
                        zIndex: -1
                    },
                    {
                        opacity: 1,
                        transform: "translateY(0) scale(1)",
                        zIndex: 1,
                        ease: "power1.out"
                    }
                ), "<")
            }
           
            this.controller = new ScrollMagic.Controller();

            this.scene = new ScrollMagic.Scene({
                triggerElement: '#hero',
                duration: '100%',
                triggerHook: 0
            });

            this.scene.setTween(tween)
            .setPin('#hero')
            .addTo(this.controller);
        }

        adjustPaddingTop(){
            var header = document.querySelector('custom-header');
            if(header){
                setTimeout(() => {
                    var headerHeight = header.offsetHeight;

                    if(document.querySelector('custom-announcement-bar')){
                        headerHeight = headerHeight + document.querySelector('custom-announcement-bar').offsetHeight;
                    }
    
                    this.querySelectorAll('.hero__slide').forEach(( item ) => {
                        item.style.paddingTop = `${headerHeight}px`;
                    })
                }, 500)
            }
        }

        adjustHeight(){
            var maxHeight = 0;

            this.querySelectorAll('.hero__slide').forEach((item) => {
                maxHeight = (maxHeight < item.offsetHeight)? item.offsetHeight : maxHeight;
            })
            this.style.height = `${maxHeight}px`;
        }
    }

    customElements.define('custom-hero', CustomHero);
}